import { useState } from 'react';
import { EventRule } from '@/features/event-rules/schemas/event-rules.schema.ts';
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza.tsx';
import { EventRuleEditForm } from '@/features/event-rules/components/edit-event-rule/event-rule-edit-form.tsx';

export function EventRulesTableRowActionEditDialog({ eventRule }: { eventRule: EventRule }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onClose = () => setIsDialogOpen(false);

  return (
    <Credenza open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <CredenzaTrigger asChild>
        <button className="focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors select-none hover:bg-gray-100 data-disabled:pointer-events-none data-disabled:opacity-50">
          <span>Edit</span>
        </button>
      </CredenzaTrigger>
      <CredenzaContent>
        <CredenzaHeader>
          <CredenzaTitle>Edit {eventRule.eventTitle}</CredenzaTitle>
          <CredenzaDescription className="hidden">
            Update the configuration for event rule. Changes will be applied upon saving.
          </CredenzaDescription>
        </CredenzaHeader>
        <CredenzaBody className="pb-4">
          <EventRuleEditForm eventRule={eventRule} onClose={onClose} />
        </CredenzaBody>
      </CredenzaContent>
    </Credenza>
  );
}

export default EventRulesTableRowActionEditDialog;
